import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const LATERAL_LIST_WIDTH = '290px';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  containerContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 0,
  },
  lateralListsContainer: {
    width: LATERAL_LIST_WIDTH,
    height: '100%',
  },
}));

export default useStyles;
